import { navigate } from "../router";
import { el, mount, header } from "../ui";

interface Spec {
  title: string;
  icon: string;
  message: string;
}

const SPECS: Record<string, Spec> = {
  herbs: {
    title: "藥草圖鑑",
    icon: "🌱",
    message: "我們正在整理園區藥草的圖文卡片(白鶴靈芝、金銀花、魚腥草、千金藤等)。完成後將提供:中文/英文/日文名稱、成分、傳統用途、園區栽植區位置。",
  },
  map: {
    title: "園區地圖",
    icon: "🗺️",
    message: "互動地圖開發中。將包含:步道路線、無障礙路線、餐廳/廁所/休息點位置、藥草區索引。",
  },
  events: {
    title: "活動報名",
    icon: "📅",
    message: "近期工作坊、節氣講座、藥草料理體驗。完成後可在這裡查看時段、線上報名。",
  },
  restaurant: {
    title: "餐廳訂位",
    icon: "🍲",
    message: "汆燙鍋與健康養生餐線上訂位開發中。預計支援:時段預約、人數選擇、特殊飲食(素食/過敏)備註。",
  },
};

export function renderPlaceholder(name: string): void {
  const spec = SPECS[name];
  if (!spec) {
    navigate("home");
    return;
  }

  const head = header({
    title: spec.title,
    subtitle: "敬請期待",
    back: () => navigate("home"),
  });

  const body = el("section", { class: "placeholder" }, [
    el("div", { class: "icon" }, [spec.icon]),
    el("h2", {}, ["敬請期待"]),
    el("p", {}, [spec.message]),
    el("p", {}, ["想先諮詢的話,可以直接跟「原生小幫手」對話 🌿"]),
  ]);

  const back = el("div", { class: "actions" }, []);
  const btn = el("button", { class: "btn btn-primary" }, ["回主選單"]);
  btn.addEventListener("click", () => navigate("home"));
  back.appendChild(btn);

  mount(head, body, back);
}
